<nb-card [accent]="accent" [ngClass]="['accent-' + accent, filled ? 'accent-as-background' : '']">
    <nb-card-body>
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-2" *ngIf="entityAvatar || tag">
            <nb-user
                [picture]="entityAvatar"
                [name]="entity"
                size="small"
                [onlyPicture]="onlyPicture"
                *ngIf="entityAvatar"
            ></nb-user>
            <nb-tag-list class="mb-2" *ngIf="tag">
                <nb-tag
                    [appearance]="filled ? 'filled' : 'outline'"
                    [status]="filled ? 'basic' : accent"
                    [text]="tag"
                    size="small"
                ></nb-tag>
            </nb-tag-list>
        </div>
        <ng-content select="[tag]" *ngIf="!tag"></ng-content>
        <h4 class="card-title">{{ title }}</h4>
        <div class="card-info">
            <div class="d-flex align-items-start mb-2">
                <nb-icon icon="calendar-outline"></nb-icon>
                <p class="ml-1 mb-0">{{ date }}</p>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-start">
                    <nb-icon icon="pin-outline"></nb-icon>
                    <p class="ml-1 mb-0">{{ location }}</p>
                </div>
                <div class="d-flex align-items-start" *ngIf="department">
                    <nb-icon icon="people-outline"></nb-icon>
                    <p class="ml-1 mb-0">{{ department }}</p>
                </div>
            </div>
        </div>
    </nb-card-body>
</nb-card>
